var React = require('react');

function AudioPlayIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#29C2DF;}\n\t.st1{fill:#FFFFFF;}\n"),React.createElement("rect",{"x":"5.3","y":"5.3","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -7.4558 18)","className":"st0","width":"25.5","height":"25.5","key":1}),React.createElement("g",{"key":2},React.createElement("polygon",{"className":"st1","points":"17,13.5 17,22.5 23,18 \t"}))]);
}

AudioPlayIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 36 36","style":{"enableBackground":"new 0 0 36 36"},"xmlSpace":"preserve"};

module.exports = AudioPlayIcon;

AudioPlayIcon.default = AudioPlayIcon;
